export default __webpack_public_path__ + "static/media/mb.56f25565.svg";